import React from "react";
import { X } from "./X";
import { Component3 } from "./Component3";
import { Variant1_1 } from "./Variant1_1";
import { YT } from "./YT";
import { IG } from "./Instagram";

interface Props {
  className?: string;
}

const currentYear = new Date().getFullYear();

export const Footer: React.FC<Props> = ({ className }) => {
  return (
    <section
      className={`relative flex w-full flex-col overflow-hidden bg-[#08111d] text-white ${className ?? ""}`}
    >
      <div className="h-40 w-full bg-[url(/images/wallblue.webp)] bg-cover bg-center sm:h-52 lg:h-64" aria-hidden="true">
        <div className="h-full w-full bg-gradient-to-b from-[#08111d]/20 via-[#08111d]/55 to-[#08111d]" />
      </div>

      <footer className="relative -mt-14 px-4 pb-6 sm:px-6 lg:px-10">
        <div className="mx-auto max-w-[1180px] overflow-hidden rounded-[30px] border border-white/[0.1] bg-[#ec4e20] shadow-[0_28px_90px_rgba(0,0,0,0.38)]">
          <div className="grid gap-10 px-6 py-8 sm:px-10 sm:py-10 lg:grid-cols-[1.15fr_0.9fr_0.9fr] lg:gap-12">
            <div className="space-y-6">
              <div className="flex items-center gap-4">
                <div className="relative flex h-14 w-14 items-center justify-center rounded-2xl border border-white/[0.2] bg-white/[0.1]" aria-hidden="true">
                  <Component3 className="!absolute !left-[16px] !top-[8px] !h-[38px] !w-[38px] !object-cover" />
                  <Variant1_1 className="!absolute !left-[4px] !top-[11px] !h-[38px] !w-[38px] !object-cover" />
                </div>

                <div>
                  <p className="text-[11px] font-semibold uppercase tracking-[0.35em] text-white/[0.75]">
                    sifu.art
                  </p>
                  <h2 className="mt-1 text-[28px] font-bold italic leading-none sm:text-[32px]">
                    Follow sifu.art
                  </h2>
                </div>
              </div>

              <p className="max-w-[30rem] text-sm leading-6 text-white/[0.88] sm:text-base">
                Staff training, AI feedback, and product updates from the
                sifu.art team. Follow along as the webcam coach moves from
                preview to practice tool.
              </p>

              <div className="flex flex-wrap gap-3">
                <div className="rounded-full border border-white/[0.18] bg-black/[0.12] p-3 transition-transform duration-200 hover:-translate-y-0.5 focus-within:outline focus-within:outline-2 focus-within:outline-offset-4 focus-within:outline-white">
                  <IG className="!h-[22px] !w-[22px] !object-contain" />
                </div>
                <div className="rounded-full border border-white/[0.18] bg-black/[0.12] p-3 transition-transform duration-200 hover:-translate-y-0.5 focus-within:outline focus-within:outline-2 focus-within:outline-offset-4 focus-within:outline-white">
                  <X className="!h-[22px] !w-[22px] !object-contain" />
                </div>
                <div className="rounded-full border border-white/[0.18] bg-black/[0.12] p-3 transition-transform duration-200 hover:-translate-y-0.5 focus-within:outline focus-within:outline-2 focus-within:outline-offset-4 focus-within:outline-white">
                  <YT className="!h-[22px] !w-[22px] !object-contain" />
                </div>
              </div>
            </div>

            <div className="rounded-[24px] border border-white/[0.15] bg-black/[0.12] p-6 backdrop-blur-sm">
              <p className="text-[11px] font-semibold uppercase tracking-[0.32em] text-white/[0.7]">
                Contact
              </p>
              <p className="mt-4 text-xl font-semibold leading-8 sm:text-2xl">
                81 Hollyberry Trail
              </p>
              <p className="mt-2 text-sm leading-7 text-white/[0.88] sm:text-base">
                North York, Ontario
                <br />
                M2H 2N9
              </p>
            </div>

            <div className="rounded-[24px] border border-white/[0.15] bg-black/[0.12] p-6 backdrop-blur-sm">
              <p className="text-[11px] font-semibold uppercase tracking-[0.32em] text-white/[0.7]">
                Studio Hours
              </p>
              <p className="mt-4 text-xl font-semibold leading-8 sm:text-2xl">
                7am - 5pm GMT
              </p>
              <p className="mt-2 text-sm leading-7 text-white/[0.88] sm:text-base">
                Open 7 days a week.
                <br />
                Holiday closures may vary.
              </p>
            </div>
          </div>

          <div className="border-t border-white/[0.14] bg-[#111111]/[0.18] px-6 py-4 sm:px-10">
            <div className="flex flex-col gap-3 text-sm text-white/[0.82] sm:flex-row sm:items-center sm:justify-between">
              <p className="leading-6 text-white/[0.72]">
                Camera access is permission-based. Privacy details are coming
                with the public beta.
              </p>
              {/* <p className="leading-6">
                Terms &amp; Conditions
                <span className="px-2 text-white/[0.45]">|</span>
                Privacy Policy
                <span className="px-2 text-white/[0.45]">|</span>
                Legal Notice
              </p> */}
              <p className="leading-6">Copyright {currentYear} Sifu.art, Inc.</p>
            </div>
          </div>
        </div>
      </footer>
    </section>
  );
};
